import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { ModalType, OrganzationStatusType, VendorStore } from '../app/types';
import InspectAddOnService from '../services/InspectAddOnService';
import OrganizationService from '../services/OrganizationService';
import errorHandle from './errorHandle';
import { openModal } from './modalSlice';

export const organizationSlice = createSlice({
  name: 'organization',
  initialState: {
    systemStatus: OrganzationStatusType.INITIAL,
    integration: null,
    nextResource: null,
    isNotEnabledInsightArk: false,
  },
  reducers: {
    setOrgnaization: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const { setOrgnaization } = organizationSlice.actions;

export const getOrganization = orgId => async dispatch => {
  dispatch(setOrgnaization({ systemStatus: OrganzationStatusType.QUERYING }));
  try {
    const data = await OrganizationService.getOrganization(orgId);
    if (data) {
      dispatch(
        setOrgnaization({
          systemStatus: OrganzationStatusType.QUERYING_SUCCESS,
          ...data,
        }),
      );
    }
  } catch (error) {
    dispatch(
      setOrgnaization({ systemStatus: OrganzationStatusType.QUERYING_FAILURE }),
    );

    errorHandle(error);
  }
};

export const saveDefaultTemplate =
  (orgId, templateId, templateType, name, elements, expiredAt) => async () => {
    try {
      await OrganizationService.saveDefaultTemplate(
        orgId,
        templateId,
        templateType,
        name,
        elements,
        expiredAt,
      );
    } catch (error) {
      errorHandle(error);
    }
  };

export const getIntegration = orgId => async dispatch => {
  try {
    const data = await OrganizationService.getIntegration(orgId);
    if (data) {
      dispatch(
        setOrgnaization({
          integration: data,
        }),
      );
    }
  } catch (error) {
    errorHandle(error);
  }
};

export const getNextResource = orgId => async dispatch => {
  try {
    const response = await InspectAddOnService.getResource(
      orgId,
      VendorStore.NUMBER8_NEXT,
    );

    const InsightArk = response?.product?.InsightArk;
    const isExpire =
      InsightArk?.plan?.expireAt &&
      moment(InsightArk.plan.expireAt).isBefore(new Date());

    dispatch(
      setOrgnaization({
        nextResource: response || {},
        isNotEnabledInsightArk: !InsightArk || isExpire,
      }),
    );
    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error.response?.data?.error || error.message);

    return {};
  }
};

export const checkInsightArkProduct =
  callback => async (dispatch, getStore) => {
    try {
      const InsightArk = getStore().organization?.perm?.product?.InsightArk;

      if (!InsightArk) {
        dispatch(
          openModal({
            modalType: ModalType.CHECK_PRODUCT_MODAL,
            modalProps: {
              name: 'checkInsightArkProductModal',
            },
          }),
        );
        return false;
      }

      const isExpire = !InsightArk?.is_active;

      if (isExpire) {
        dispatch(
          openModal({
            modalType: ModalType.CHECK_PRODUCT_MODAL,
            modalProps: {
              name: 'checkInsightArkProductExpiredModal',
            },
          }),
        );
        return false;
      }

      if (callback) {
        callback();
      }

      return true;
    } catch (error) {
      return false;
    }
  };

export default organizationSlice.reducer;
